// extracted by mini-css-extract-plugin
export var questionBox = "_77-0";